<script>
	import { enhance } from '$app/forms';
	import { page } from '$app/stores';
	import { onMount } from 'svelte';
	import Button from '../Button/Button.svelte';
	import Select from '../Select/Select.svelte';
	import TextArea from '../TextArea/TextArea.svelte';
	import TextInput from '../TextInput/TextInput.svelte';
	import { t } from '@resider/i18n';
	import Turnstile from './Turnstile.svelte';

	/** @type {string} */
	export let action = undefined;
	/** @type {string} */
	export let emailPlaceholder;
	/** @type {string} */
	export let formMessage;
	/** @type {string} */
	export let formRecipentEmail = 'kontakt@resider.pl';
	/** @type {string} */
	export let formSenderEmail;
	/** @type {string} */
	export let formSenderName;
	/** @type {{ label: string; value: string; }[]} */
	export let formSubjects;
	/** @type {string | undefined} */
	export let formSubject = undefined;
	/** @type {string} */
	export let messagePlaceholder;
	/** @type {string} */
	export let namePlaceholder;
	/** @type {string} */
	export let subjectPlaceholder;
	/** @type {string} */
	export let submitLabel;

	onMount(() => {
		if ($page?.url.searchParams.has('email')) {
			formSenderEmail = $page?.url.searchParams.get('email');
		}

		if ($page?.url.searchParams.has('subject')) {
			formSubject = $page?.url.searchParams.get('subject');
		}

		if ($page?.url.searchParams.has('message')) {
			formMessage = $page?.url.searchParams.get('message');
		}
	});
</script>

{#if $page?.url.searchParams.get('success')}
	<div class="alert-message">
		<h2>Dziękujemy za przesłanie formularza!</h2>

		<p>Wkrótce się do Ciebie odezwiemy</p>

		<Button href={$page?.url.pathname}>{$t('global.Go back')}</Button>
	</div>
{:else}
	<form {action} class="contact-form" method="POST" use:enhance>
		<input name="recipent-email" type="hidden" value={formRecipentEmail} />

		<TextInput
			name="sender-name"
			placeholder={namePlaceholder}
			type="text"
			bind:value={formSenderName}
		/>

		<TextInput
			name="sender-email"
			placeholder={emailPlaceholder}
			required
			type="email"
			bind:value={formSenderEmail}
		/>

		<Select
			name="subject"
			options={formSubjects}
			placeholder={subjectPlaceholder}
			required
			bind:value={formSubject}
		/>

		<TextArea
			name="message"
			placeholder={messagePlaceholder}
			required
			rows={6}
			bind:value={formMessage}
		/>

		{#if $page?.data?.turnstileSiteKey}
			<Turnstile siteKey={$page.data.turnstileSiteKey} size="flexible" theme="light" />
		{/if}

		<Button type="submit">
			{submitLabel}
		</Button>
	</form>
{/if}

<style>.alert-message{background:hsla(var(--hsl-primary),.1);border-radius:1rem;display:grid;grid-gap:2rem;gap:2rem;align-items:center;justify-items:center;place-items:center;text-align:center;margin-top:2rem;margin-bottom:2rem;padding:4rem 1rem}.alert-message h2{font:var(--f-heading-sm-semibold);color:hsla(var(--hsl-primary))}.alert-message p{font:var(--f-ui-lg-medium)}.contact-form{display:grid;grid-gap:1rem;gap:1rem}.contact-form :global(.form-box.active:invalid){border-color:hsla(var(--c-error))!important}.contact-form :global(.form-box.active:valid){border-color:hsla(var(--c-success))}</style>
